import React, { Dispatch } from "react";

import { IgDivider, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { NoBillingAlert } from "@src/features/admin/components/NoBillingAlert";
import { ChooseCustomer } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/CustomerTab/ChooseCustomer";
import { CreateCustomer } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/CustomerTab/CreateCustomer";
import { theme } from "@src/theme";

import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "../subscriptionReducer";

interface CustomerTabProps {
  index: number;
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}
export const CustomerTab = ({
  index,
  payload,
  dispatchPayload,
}: CustomerTabProps) => {
  return (
    <Grid container direction={"column"} item rowSpacing={2} mt={2}>
      {payload.customer?.id && !payload.customer.billing ? (
        <Grid item>
          <NoBillingAlert stripeCustomerId={payload.customer.id} />
        </Grid>
      ) : null}
      <ChooseCustomer
        index={index}
        payload={payload}
        dispatchPayload={dispatchPayload}
      />
      <Grid item>
        <IgDivider>
          <IgTypography color={"tertiary"}>OR</IgTypography>
        </IgDivider>
      </Grid>
      <CreateCustomer
        dispatchPayload={dispatchPayload}
        customer={payload.customer}
        orgs={payload.orgs}
        setCustomer={(customer) =>
          dispatchPayload({ type: "setCustomer", value: customer })
        }
      />
    </Grid>
  );
};
